export default __webpack_public_path__ + "media/images/react_icons/apple_store_large-39a6e4489f940ccda21986c95ac8a9d7.png";